import { Box, Paper, Grid, Typography } from "@mui/material";
import { DATA } from "./dataDictionary.json";

export const LookupTnDataGlossary = () => {
  return (
    <>
      <Box className="lookup-tn-data-dictionary">
        <Paper sx={{ padding: 4, borderRadius: 2, mt: 4 }} elevation={4}>
          <Grid container spacing={4}>
            <Grid size={12}>
              <Typography variant="h4">Glossary of Terms</Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="h5">Key</Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 8, md: 8 }}>
              <Typography variant="h5">Description</Typography>
            </Grid>

            {DATA.sort((a, b) =>
              a.key.toLowerCase().localeCompare(b.key.toLowerCase())
            ).map((dictObj) => {
              return (
                <>
                  <Grid
                    size={{ xs: 12, sm: 4, md: 4 }}
                    sx={(theme) => {
                      return {
                        [theme.breakpoints.down("sm")]: {
                          borderTop: "1px solid black",
                        },
                        [theme.breakpoints.up("sm")]: {
                          borderRight: "1px solid black",
                        },
                      };
                    }}
                  >
                    {dictObj.key}
                  </Grid>

                  <Grid
                    size={{ xs: 12, sm: 8, md: 8 }}
                    className="lookup-tn-data-dictionary-info-description"
                  >
                    {dictObj.description}
                  </Grid>
                </>
              );
            })}
          </Grid>
        </Paper>
      </Box>
    </>
  );
};
